import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useLayoutContext } from "../../layouts/general-layout";
import { RouterConstant } from "../../routers/index";
import { useUserStore } from '../../utils/userStore';
import { UserType } from "../../types/userType";


import "./user-registration-initial.scss";
import LoginHeader from '../../components/login-header';
import Button from '../../components/button';

export default function Index() {
    const { t } = useLayoutContext();
    const navigate = useNavigate();
    const { ROUTERS_PATH } = RouterConstant;
    const { setUserInfo } = useUserStore();
    
    const [searchParams] = useSearchParams();
    const authErr = searchParams.get("auth_err");
    const [showAlert, setShowAlert] = useState(authErr === "cookie_blocked");

    const handleBackClick = () => {
        navigate(ROUTERS_PATH.ROOT_PATH);
    };

    const handleRegisterClick = () => {
        setUserInfo({ userType: UserType.REGULAR_USER }); // ✅ Set default "through school" on register start
        navigate(ROUTERS_PATH.USERREGISTRATIONSTEP1);
    };

    const handleExistingUserClick = () => {        
        navigate(ROUTERS_PATH.LOGIN);
    };    

    const handleAdminClick = () => {
        navigate(ROUTERS_PATH.LOGIN, { state: { expectedUserTypes: [UserType.ADMIN], fromAdminLogin: true } });
    };

    const handleTeacherClick = () => {
        navigate(ROUTERS_PATH.LOGIN, { state: { expectedUserTypes: [UserType.TEACHER], fromTeacherLogin: true } });
    };


    return (
        <div className="full-head-template login-page">
            <LoginHeader handleBackClick={handleBackClick} subtitle={t("howToRegister")}/>
            
            {showAlert && (
                <div className="premium-cookie-alert-container">
                    <div className="premium-cookie-alert">
                        <button 
                            type="button" 
                            className="close-alert-btn" 
                            onClick={() => setShowAlert(false)}
                            aria-label="Close"
                        >
                            &times;
                        </button>
                        <h3 className="alert-title">{t("cookieBlockedTitle")}</h3>
                        <p className="alert-desc">{t("cookieBlockedDesc")}</p>
                        
                        <div className="alert-steps-section">
                            <h4 className="steps-title">{t("cookieBlockedInstructionsTitle")}</h4>
                            <ul className="steps-list">
                                <li>
                                    <span className="platform-icon">🍎</span>
                                    <span className="step-text">{t("cookieBlockedSafari")}</span>
                                </li>
                                <li>
                                    <span className="platform-icon">🌐</span>
                                    <span className="step-text">{t("cookieBlockedChrome")}</span>
                                </li>
                                <li>
                                    <span className="platform-icon">💻</span>
                                    <span className="step-text">{t("cookieBlockedDesktop")}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}

            <form className="login-page-form" onSubmit={(e) => e.preventDefault()}>
                <div className="login-page-form-fields">                    
                    <Button text={t('registeredStudent')} className='outline-button google-button' onClick={handleExistingUserClick}/>
                    <Button text={t('newStudent')} className='outline-button google-button' onClick={handleRegisterClick}/>
                    <Button text={t('systemadmin')} className='outline-button google-button desktop-only-btn' onClick={handleAdminClick}/>
                    <Button text={t('teacher')} className='outline-button google-button desktop-only-btn' onClick={handleTeacherClick}/>
                </div>     
            </form>
        </div>
    );
}